import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { PublicView } from './components/PublicView';
import { useAuth } from './hooks/useAuth';
import { theme } from './theme';
import { User } from './types';


function App() {
    const { isAuthenticated, token, user, login, logout } = useAuth();

    const handleLogin = (token: string, user: User) => {
        login(token, user);
    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    {/* Public route for viewing templates */}
                    <Route 
                        path="/public/view/:encryptedId" 
                        element={<PublicView />} 
                    />
                    
                    {/* Main application routes */}
                    <Route 
                        path="/*" 
                        element={
                            isAuthenticated ? (
                                <Dashboard onLogout={logout} authToken={token} user={user} />
                            ) : (
                                <Login onLogin={handleLogin} />
                            )
                        } 
                    />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App; 